export const columnsAssocietedInvoice = [
    {
        field: 'invoiceNumber',
        headerName: 'Número de Factura',
        width: 200,
        sortable: false,
    },
    {
        field: 'invoiceDate',
        headerName: 'Fecha Factura',
        width: 200,
        sortable: false,
    },
    {
        field: 'state',
        headerName: 'Estado',
        width: 200,
        sortable: false,
    },
    {
        field: 'fileNumber',
        headerName: 'Número de radicado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'filingDate',
        headerName: 'Fecha de Radicado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'assignedAuditor',
        headerName: 'Auditor Asignado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'auditDate',
        headerName: 'Fecha de Auditoria',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'invoiceTotal',
        headerName: 'Total factura',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'valueAssessed',
        headerName: 'Valor Avalado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'glossedValue',
        headerName: 'Valor Glosado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'acceptedValue',
        headerName: 'Valor Aceptado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'valueNotAccepted',
        headerName: 'Valor No Aceptado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'sustainedValue',
        headerName: 'Valor Sustentado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'valuePaid',
        headerName: 'Valor Pagado',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'amountCreditNotes',
        headerName: 'Valor Notas Crédito',
        width: 200,
        sortable: false,
        
    },
    {
        field: 'debitNoteValue',
        headerName: 'Valor Nota Debito',
        width: 200,
        sortable: false,
    }

]